import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { AllSecondaryDeploymentReport } from "../../../Apis/TransferStationReport/secondaryDeploymentTransactionReportApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import ExcelJS from "exceljs";
import isGHMC, { getCurrentDateTime1, getToken } from "../../../Common/helper/helpar";
import { GetZone, GetVehicleType } from "../../../Apis/organizationApi";
import Select from "react-select";
import { TableLoader } from "../../../Common/ShimmerLoader";
import CommonApiStore from "../MainStore/commonApiStore";
import { exportToPDF } from "../../../../utils/exportToPDF";
import ExportMenu from "../../../Common/ExportMenu/ExportMenu";
import axiosInstance from "../../../../Hooks/axoisInstance";
import { API_BASE_URL } from "../../../Services/baseApiUrl";
const DHWWasteCollectionReport = ({ t }) => {
    const { fetchAllCommonReportsApi, commonReportsData, loading } = CommonApiStore()
    const formatDateForDisplay = (dateString) => {
        const date = new Date(dateString);
        const options = { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" };
        return date.toLocaleString("en-GB", options).replace(",", "");
    };
    const headers = [
        "zone",
        "date",
        "vehicleNumber",
        "vehicleType", 
        "driverName",
        "driverNumber",
        "pickupDateTime",
        "latitude",
        "longitude",
        "beforeImage",
        "afterImage",
    ];

    const transformedData = commonReportsData.map((item) => ({
        ...item,
        status: item.status ? "Active" : "Inactive",
        date: formatDateForDisplay(item.createdDate) || "N/A",
        driverName: item.driverName || "N/A",
        driverNumber: item.mobileNumber || "N/A",
        zone: item.zoneName || "N/A",
            vehicleType: item.vehicleType || item.VehicleType || item.vehicle_type || "N/A",  // ✅ Added
        pickupDateTime: formatDateForDisplay(item.beforeDateTime) || "N/A",
        latitude: item.beforeLatitude || "N/A",
        longitude: item.beforeLongitude || "N/A",
        beforeImage: item.beforeImageUrl || "N/A",
        afterImage: item.afterImageUrl || "N/A",
    }));
    const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
    const [startDate, setStartDate] = useState(getStartOfCurrentDate());
    const [endDate, setEndDate] = useState(getCurrentDateTime());
    const [vehicleNumber, setVehicleNumber] = useState("");
    const [allZones, setAllZones] = useState("");
    const [zoneId, setZoneId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isExcelLoading, setIsExcelLoading] = useState(false);
const [isExcelWithImagesLoading, setIsExcelWithImagesLoading] = useState(false);
    const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
const [selectedVehicleTypes, setSelectedVehicleTypes] = useState([]);

    const isProd = isGHMC();



    const fetchAllZoneData = async () => {
        try {
            const zonesData = await GetZone();
            setAllZones(zonesData);
        } catch (error) {
            console.error("Error fetching initial data:", error);
        }
    };
const fetchAllVehicleTypeData = async () => {
    try {
        const vehicleTypesData = await GetVehicleType();
        setVehicleTypeDetails(vehicleTypesData);
    } catch (error) {
        console.error("Error fetching vehicle types:", error);
    }
};

const getSelectedVehicleTypeIds = () => selectedVehicleTypes.map(v => v.value);
    

    useEffect(() => {
        fetchAllZoneData();
        fetchAllVehicleTypeData();
        fetchAllCommonReportsApi("8", startDate, endDate, zoneId, vehicleNumber, getSelectedVehicleTypeIds());
    }, []);

    const handleFormSubmit = (e) => {
        e.preventDefault();
        fetchAllCommonReportsApi("8", startDate, endDate, zoneId, vehicleNumber, getSelectedVehicleTypeIds());
    };

    // Function to format dates for display


    const options = { day: "numeric", month: "numeric", year: "numeric" };
    const generationTime = ` ${new Date().toLocaleString("en-GB", options).replace(/\//g, "/")}`;
    const downloadAsExcel = async () => {
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
        const cumulativeHeadingReport = `DHW C&T Waste Collection & Transportation Report ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)} - (at ${getCurrentDateTime1()})`;
        const downloadDateTime = `Report on: ${generationTime}, ${formattedTime}`;
        const dateRange = `Date Range: ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)}`;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("DHW C&T Waste Collection & Transportation Report");
        const boldFont = { bold: true };

        // Add Report Generation Date
        worksheet.addRow(["", downloadDateTime, ""]);
        worksheet.mergeCells(1, 2, 1, 8);
        worksheet.getCell(1, 2).value = downloadDateTime;
        worksheet.getCell(1, 2).font = boldFont;
        worksheet.getCell(1, 2).alignment = { horizontal: "center" };

        for (let col = 2; col <= 6; col++) {
            worksheet.getCell(1, col).font = boldFont;
            worksheet.getCell(1, col).alignment = { horizontal: "center" };
        }
        for (let col = 2; col <= 12; col++) {
            worksheet.getCell(2, col).font = boldFont;
            worksheet.getCell(2, col).alignment = { horizontal: "center" };
        }

        // Add Report Title
        worksheet.addRow(["", cumulativeHeadingReport, ""]);
        worksheet.mergeCells(2, 2, 3, 8);
        worksheet.getCell(3, 2).value = cumulativeHeadingReport;
        worksheet.getCell(3, 2).font = boldFont;
        worksheet.getCell(3, 2).alignment = { horizontal: "center" };

        for (let col = 2; col <= 12; col++) {
            worksheet.getCell(3, col).font = boldFont;
            worksheet.getCell(3, col).alignment = { horizontal: "center" };
        }

        // Add empty row for spacing
        worksheet.addRow([""]);

        // Add table header row with bold font
        const tableHeaderRow = worksheet.addRow([
            "S.No",
            "Zone",
            "Date",
            "Vehicle Number",
            "Vehicle Type",
            "Driver Name",
            "Driver Number",
            "Pickup Date Time",
            "Latitude",
            "Longitude",
        ]);

        tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            cell.font = boldFont;
            cell.alignment = { horizontal: "left" };
            if (colNumber >= 1 && colNumber <= 15) {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "F6B1B1" },
                };
            }
        });
        transformedData.forEach((item, index) => {
            worksheet.addRow([
                index + 1,
                item.zoneName ?? "N/A",
                formatDateForDisplay(item.createdDate) || "N/A",
                item.vehicleNumber ?? "N/A",
                item.vehicleType ?? "N/A",
                item.driverName ?? "N/A",
                item.driverNumber ?? "N/A",
                formatDateForDisplay(item.beforeDateTime) ?? "N/A",
                item.beforeLatitude ?? "N/A",
                item.beforeLongitude ?? "N/A",
            ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
                if (colNumber >= 1 && colNumber <= 15) {
                    cell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };
                } else {
                    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
                }
            });
        });

        // Set column widths dynamically based on content
        worksheet.columns = [
            { width: 5 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },

        ];

        // Save the workbook to a file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "DHW C&T Waste Collection & Transportation Report.xlsx";
        a.click();
        URL.revokeObjectURL(url);
    };

    // const dowanloadExcel = async () => {
    //     setIsExcelDowanload(true);
    //     try {
    //       const response = await axiosInstance.get(
    //         `${API_BASE_URL}api/SecondaryCollection/UnifiedWasteCollectionTransportationReportDownloadExcelSheet`,
    //         {
    //           params: {
    //             CollectionPointTypeId:8,
    //             FromDate:startDate,
    //             ToDate:endDate,
    //             ZoneId: zoneId,
    //             VehicleNumber: vehicleNumber,
    //           },
    //           headers: {
    //             Authorization: `Bearer ${getToken()}`,
    //           },
    //           responseType: "blob", // 🔥 VERY IMPORTANT
    //         },
    //       );
    
    //       // ✅ Create downloadable file
    //       const blob = new Blob([response.data], {
    //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //       });
    
    //       const url = window.URL.createObjectURL(blob);
    
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.download = "Timely Street sweeping B/A.xlsx"; // or backend filename
    //       document.body.appendChild(link);
    //       link.click();
    
    //       // Cleanup
    //       link.remove();
    //       window.URL.revokeObjectURL(url);
    //     } catch (error) {
    //       console.error("Excel download failed", error);
    //     } finally {
    //       setIsExcelDowanload(false);
    //     }
    //   };


const dowanloadExcel = async (withImages = false) => {
        if (withImages) {
    setIsExcelWithImagesLoading(true);
    } else {
        setIsExcelLoading(true);
    }
  try {
    const vehicleTypeIds = getSelectedVehicleTypeIds();

    const params = new URLSearchParams();
    params.append("CollectionPointTypeId", 8);  // ← was 11, must match "8"
    params.append("FromDate", startDate);
    params.append("ToDate", endDate);
    if (zoneId) params.append("ZoneId", zoneId);
    if (vehicleNumber) params.append("VehicleNumber", vehicleNumber);
    if (withImages) params.append("withImages", "true");

if (vehicleTypeIds.length > 0) {
      params.append("vehicleTypeIds", vehicleTypeIds.join(","));
    }
    const response = await axiosInstance.get(
      `${API_BASE_URL}api/SecondaryCollection/UnifiedWasteCollectionTransportationReportDownloadExcelSheet?${params.toString()}`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "DHW C&T Waste Collection & Transportation Report.xlsx";  // ← fixed name
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Excel download failed", error);
  } finally {
    setIsExcelLoading(false);
    setIsExcelWithImagesLoading(false);
  }
};

    const downloadPdf = async () => {
        console.log("transformedData:", transformedData);
        if (!transformedData || transformedData.length === 0) {
            alert("No data available to generate PDF.");
            return;
        }
        try {
            console.log("Starting PDF generation...");
            await exportToPDF({
                fileName: "Timely Street sweeping B/A",
                title: "Timely Street sweeping B/A",
                generatedOnText: `Report on: ${generationTime}, ${getCurrentDateTime1()}`,
                data: transformedData,
                columns: [
                    {
                        header: "S.No",
                        accessor: (_row, index) => index + 1,
                        width: 10,
                    },
                    {
                        header: "Zone",
                        accessor: row => row.zoneName ?? "N/A",
                        width: 25,
                    },
                    {
                        header: "Date",
                        accessor: row =>
                            formatDateForDisplay(row.createdDate) || "N/A",
                        width: 25,
                    },
                    {
                        header: "Vehicle Number",
                        accessor: row => row.vehicleNumber ?? "N/A",
                        width: 30,
                    },
                    {
                        header: "Vehicle Type",
                        accessor: row => row.vehicleType ?? "N/A",
                        width: 30,
                    },
                    {
                        header: "Driver Name",
                        accessor: row => row.driverName ?? "N/A",
                        width: 30,
                    },
                    {
                        header: "Driver Number",
                        accessor: row => row.driverNumber ?? "N/A",
                        width: 28,
                    },
                    {
                        header: "Pickup Date Time",
                        accessor: row =>
                            formatDateForDisplay(row.beforeDateTime) ?? "N/A",
                        width: 35,
                    },
                    {
                        header: "Latitude",
                        accessor: row => row.beforeLatitude ?? "N/A",
                        width: 22,
                    },
                    {
                        header: "Longitude",
                        accessor: row => row.beforeLongitude ?? "N/A",
                        width: 22,
                    },
                    {
                        header: "Before Image",
                        accessor: (r) => r.beforeImageUrl,
                        isImage: true,
                        width: 20,
                    },
                    {
                        header: "After Image",
                        accessor: (r) => r.afterImageUrl,
                        isImage: true,
                        width: 20,
                    },
                ],
                landscape: true, // auto-fit + auto-center
            });
            console.log("PDF generation completed.");
        } catch (error) {
            console.error("PDF download failed:", error);
            alert("Failed to download PDF. Please try again.");
        }
    }

    return (
        <>
            {loading ? (
                <TableLoader height={500} />
            ) : (
                <div style={{ width: "100%" }}>
                    <div className="content">
                        <div className="page-content">
                            <h4 className="text-start mb-3">
                                {t("Timely Street sweeping B/A")} ({formatDateForDisplay(startDate)} to {formatDateForDisplay(endDate)}) (at {getCurrentDateTime1()})
                            </h4>
                            <div className="card">
                                <div className="card-body p-3">
                                    <div className="row align-items-end">
                                        <div className="col-md-12">
                                            <form onSubmit={handleFormSubmit}>
                                                <div className="row" style={{ textAlign: "left" }}>
                                                    <div className="col-md-2">
                                                        <label>From Date & Time:</label>
                                                        <input
                                                            type="datetime-local"
                                                            name="FromDate"
                                                            style={inputStyle}
                                                            value={startDate}
                                                            className="form-control"
                                                            max={endDate ? endDate : getCurrentDateTime()}
                                                            onChange={(e) => setStartDate(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label>To Date & Time:</label>
                                                        <input
                                                            type="datetime-local"
                                                            name="ToDate"
                                                            style={inputStyle}
                                                            value={endDate}
                                                            className="form-control"
                                                            min={startDate}
                                                            max={getCurrentDateTime()}
                                                            onChange={(e) => setEndDate(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label>Vehicle Number</label>
                                                        <input
                                                            type="text"
                                                            name="vehicleTypeCode"
                                                            style={inputStyle}
                                                            placeholder="Vehicle Number"
                                                            className="form-control"
                                                            value={vehicleNumber}
                                                            onChange={(e) => {
                                                                setVehicleNumber(e.target.value.replace(/\s+/g, ""));
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="VehicleTypeId">Vehicle Type</label>
                                                        <Select
                                                            isMulti
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                            name="vehicleTypes"
                                                            options={vehicleTypeDetails
                                                                .filter((v) => v.isActive)
                                                                .map((v) => ({ value: v.vehicleTypeId, label: v.vehicleTypeName }))}
                                                            value={selectedVehicleTypes}
                                                            onChange={(selected) => setSelectedVehicleTypes(selected || [])}
                                                            placeholder="Select Vehicle Types"
                                                            isClearable
                                                        />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="ZoneId">Zone:</label>
                                                        <select
                                                            name="ZoneId"
                                                            className="form-select"
                                                            value={zoneId}
                                                            onChange={(e) => setZoneId(e.target.value)}
                                                        >
                                                            <option value="">Select</option>
                                                            {allZones &&
                                                                allZones
                                                                    ?.filter((zone) => zone.isActive)
                                                                    .map((zone) => (
                                                                        <option key={zone.zoneId} value={zone.zoneId}>
                                                                            {zone.zoneName}
                                                                        </option>
                                                                    ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-5 d-flex align-items-center gap-2 mt-4">
                                                        <button
                                                            type="submit"
                                                            className={`btn ${isProd ? "search-ghmc" : "search-swm"}`}
                                                        >
                                                            Search
                                                        </button>
                                                        <ExportMenu
                                                            items={[
                                                                {
                                                                    label: "Excel",
                                                                    icon: "fa-solid fa-file-excel",
                                                                    onClick: () => dowanloadExcel(false),
                                                                    loading: isExcelLoading,
                                                                },
                                                                {
                                                                    label: "Excel + Images",
                                                                    icon: "fa-solid fa-file-excel",
                                                                    onClick: () => dowanloadExcel(true),
                                                                    loading: isExcelWithImagesLoading,
                                                                },
                                                                {
                                                                    label: "PDF",
                                                                    icon: "fa-solid fa-file-pdf",
                                                                    onClick: () => downloadPdf(),
                                                                },
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                    <div className="mt-3">
                                        <div className="">
                                            <TableComponent isLoading={isLoading}
                                                DataFetchURL={transformedData}
                                                headers={headers}
                                                imgField="image"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hour}:${minute}`;
};

// Styles for input and button
const inputStyle = {
    border: "1px solid #E2E2E2",
    padding: "15px",
};

const buttonStyle = {
    border: "1px solid #E2E2E2",
    borderRadius: "5px",
    color: "#fff",
};

export default withTranslation()(DHWWasteCollectionReport);